/**
 * Password expiry, as the authentication service reports it. A password sign-in refused because the
 * password is older than 90 days answers 403 with a one-time change-password link in `data` (valid for
 * 15 minutes). A sign-in that succeeds within 14 days of expiry carries a warning flag.
 */

/** Where sign-in continues when it was refused because the password expired; null otherwise. */
export const expiredPasswordPath = (error: unknown): string | null => {
  const res = (error as {
    response?: { status?: number; data?: { data?: { password_expired?: boolean; encoded_pk?: string; token?: string } } };
  })?.response;
  const link = res?.status === 403 ? res.data?.data : undefined;
  if (!link?.password_expired || !link.encoded_pk || !link.token) return null;
  return `/login/reset-password/${link.encoded_pk}/${link.token}`;
};

/** Toast text once the password is inside its expiry warning window; null before that. */
export const passwordExpiryWarning = (
  data?: { password_expires_in_days?: number; password_expiry_warning?: boolean } | null
): string | null => {
  if (!data?.password_expiry_warning) return null;
  const days = data.password_expires_in_days ?? 0;
  const when = days < 1 ? "within a day" : `in ${days} ${days === 1 ? "day" : "days"}`;
  return `Your password expires ${when}. You can change it from your profile.`;
};
